import { VisitDocumentsDiagnosesFormBean } from './VisitDocumentsDiagnosesForm.types';

export const INITIAL_FORM_VALUES: VisitDocumentsDiagnosesFormBean = { diagnoses: { search: null, value: [] } };
